function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005A83",
  d: "M3 2L3 5L4 5L4 2L3 2 z M 7 2L7 5L8 5L8 2L7 2 z M 11 2L11 5L12 5L12 2L11 2 z M 5 3L5 5L6 5L6 3L5 3 z M 9 3L9 5L10 5L10 3L9 3 z M 0.5 6 A 0.50005 0.50005 0 1 0 0.5 7L1 7L1 8.5C1 9.88857 1.8227084 11.083571 3 11.648438L3 12C3 12.557469 2.5574686 13 2 13L2 14C3.0985314 14 4 13.098531 4 12L4 11.949219C4.1648291 11.973212 4.3287174 12 4.5 12L10.5 12C10.671283 12 10.835171 11.973212 11 11.949219L11 12C11 13.098531 11.901469 14 13 14L13 13C12.442531 13 12 12.557469 12 12L12 11.648438C13.177292 11.083571 14 9.88857 14 8.5L14 7L14.5 7 A 0.50005 0.50005 0 1 0 14.5 6L14 6L1 6L0.5 6 z M 2 7L13 7L13 8.5C13 9.886833 11.886833 11 10.5 11L4.5 11C3.113167 11 2 9.886833 2 8.5L2 7 z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgIcons8Spa = function SvgIcons8Spa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8Spa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8_spa.8b957d69.svg";
export { ForwardRef as ReactComponent };